module.exports = __webpack_public_path__ + "img/921_page_background4.037ee08b.jpg";